import { MOCK_ERRORS } from 'constants/global';
import { toast } from 'react-toastify';

export * from './scrollVertical';
export * from './downloadURLFile';
export * from './localStorageUtils';
export * from './firebase';

const RANDOM_ERROR_MSG = MOCK_ERRORS[Math.floor(Math.random() * MOCK_ERRORS.length)].message;

export const randomDelay = (setLoading, min = 4500, max = 17500) => {
    setLoading(true);
    setTimeout(
        () => {
            toast.error(RANDOM_ERROR_MSG);
            setLoading(false);
        },
        Math.floor(Math.random() * (max - min + 1)) + min
    );
};
